module.exports = __webpack_public_path__ + "static/media/portfolio-diversity.717cec40.png";